/**
 * אזרחות לטופס נוסעי טיסה.
 *
 * חוזה לנתונים (LDS / ספקים): שמור ב־`passenger.nationality` רק קוד ISO 3166-1 alpha-2
 * באותיות גדולות (למשל IL, US). לתצוגה: `getNationalityDisplayLabel(code)`.
 *
 * מקור רשימה: `countries-list`; שמות עברית ב־`COUNTRY_NAME_HE` (הרחבה הדרגתית).
 */
import { countries } from "countries-list";

/** @type {Record<string, string>} קוד ISO → שם עברי (הרחבה לפי צורך) */
export const COUNTRY_NAME_HE = {
  AD: "אנדורה",
  AE: "איחוד האמירויות הערביות",
  AF: "אפגניסטן",
  AG: "אנטיגואה וברבודה",
  AI: "אנגווילה",
  AL: "אלבניה",
  AM: "ארמניה",
  AO: "אנגולה",
  AR: "ארגנטינה",
  AT: "אוסטריה",
  AU: "אוסטרליה",
  AZ: "אזרבייג׳ן",
  BA: "בוסניה והרצגובינה",
  BB: "ברבדוס",
  BD: "בנגלדש",
  BE: "בלגיה",
  BF: "בורקינה פאסו",
  BG: "בולגריה",
  BH: "בחריין",
  BI: "בורונדי",
  BJ: "בנין",
  BM: "ברמודה",
  BN: "ברוניי",
  BO: "בוליביה",
  BR: "ברזיל",
  BS: "איי בהאמה",
  BT: "בהוטן",
  BW: "בוטסואנה",
  BY: "בלארוס",
  BZ: "בליז",
  CA: "קנדה",
  CD: "קונגו (הרפובליקה הדמוקרטית)",
  CF: "הרפובליקה המרכז-אפריקאית",
  CG: "קונגו",
  CH: "שווייץ",
  CI: "חוף השנהב",
  CL: "צ׳ילה",
  CM: "קמרון",
  CN: "סין",
  CO: "קולומביה",
  CR: "קוסטה ריקה",
  CU: "קובה",
  CV: "כף ורדה",
  CY: "קפריסין",
  CZ: "צ׳כיה",
  DE: "גרמניה",
  DJ: "ג׳יבוטי",
  DK: "דנמרק",
  DM: "דומיניקה",
  DO: "הרפובליקה הדומיניקנית",
  DZ: "אלג׳יריה",
  EC: "אקוודור",
  EE: "אסטוניה",
  EG: "מצרים",
  ER: "אריתריאה",
  ES: "ספרד",
  ET: "אתיופיה",
  FI: "פינלנד",
  FJ: "פיג׳י",
  FR: "צרפת",
  GA: "גבון",
  GB: "בריטניה",
  GD: "גרנדה",
  GE: "גאורגיה",
  GH: "גאנה",
  GI: "גיברלטר",
  GL: "גרינלנד",
  GM: "גמביה",
  GN: "גינאה",
  GQ: "גינאה המשוונית",
  GR: "יוון",
  GT: "גואטמלה",
  GW: "גינאה ביסאו",
  GY: "גיאנה",
  HK: "הונג קונג",
  HN: "הונדורס",
  HR: "קרואטיה",
  HT: "האיטי",
  HU: "הונגריה",
  ID: "אינדונזיה",
  IE: "אירלנד",
  IL: "ישראל",
  IN: "הודו",
  IQ: "עיראק",
  IR: "איראן",
  IS: "איסלנד",
  IT: "איטליה",
  JM: "ג׳מייקה",
  JO: "ירדן",
  JP: "יפן",
  KE: "קניה",
  KG: "קירגיזסטן",
  KH: "קמבודיה",
  KM: "קומורו",
  KN: "סנט קיטס ונוויס",
  KP: "צפון קוריאה",
  KR: "דרום קוריאה",
  KW: "כווית",
  KY: "איי קיימן",
  KZ: "קזחסטן",
  LA: "לאוס",
  LB: "לבנון",
  LC: "סנט לוסיה",
  LI: "לטנשטיין",
  LK: "סרי לנקה",
  LR: "ליבריה",
  LS: "לסוטו",
  LT: "ליטא",
  LU: "לוקסמבורג",
  LV: "לטביה",
  LY: "לוב",
  MA: "מרוקו",
  MC: "מונקו",
  MD: "מולדובה",
  ME: "מונטנגרו",
  MG: "מדגסקר",
  MK: "צפון מקדוניה",
  ML: "מאלי",
  MM: "מיאנמר",
  MN: "מונגוליה",
  MO: "מקאו",
  MR: "מאוריטניה",
  MT: "מלטה",
  MU: "מאוריציוס",
  MV: "איים המלדיביים",
  MW: "מלאווי",
  MX: "מקסיקו",
  MY: "מלזיה",
  MZ: "מוזמביק",
  NA: "נמיביה",
  NE: "ניז׳ר",
  NG: "ניגריה",
  NI: "ניקרגואה",
  NL: "הולנד",
  NO: "נורווגיה",
  NP: "נפאל",
  NZ: "ניו זילנד",
  OM: "עומאן",
  PA: "פנמה",
  PE: "פרו",
  PG: "פפואה גינאה החדשה",
  PH: "הפיליפינים",
  PK: "פקיסטן",
  PL: "פולין",
  PR: "פוארטו ריקו",
  PS: "פלסטין",
  PT: "פורטוגל",
  PY: "פרגוואי",
  QA: "קטאר",
  RO: "רומניה",
  RS: "סרביה",
  RU: "רוסיה",
  RW: "רואנדה",
  SA: "ערב הסעודית",
  SB: "איי שלמה",
  SC: "איי סיישל",
  SD: "סודן",
  SE: "שוודיה",
  SG: "סינגפור",
  SI: "סלובניה",
  SK: "סלובקיה",
  SL: "סיירה לאון",
  SM: "סן מרינו",
  SN: "סנגל",
  SO: "סומליה",
  SR: "סורינאם",
  SS: "דרום סודן",
  ST: "סאו טומה ופרינסיפה",
  SV: "אל סלבדור",
  SY: "סוריה",
  SZ: "אסוואטיני",
  TD: "צ׳אד",
  TG: "טוגו",
  TH: "תאילנד",
  TJ: "טג׳יקיסטן",
  TL: "טימור-לסטה",
  TM: "טורקמניסטן",
  TN: "תוניסיה",
  TR: "טורקיה",
  TT: "טרינידד וטובגו",
  TW: "טייוואן",
  TZ: "טנזניה",
  UA: "אוקראינה",
  UG: "אוגנדה",
  US: "ארצות הברית",
  UY: "אורוגוואי",
  UZ: "אוזבקיסטן",
  VA: "הוותיקן",
  VC: "סנט וינסנט והגרנדינים",
  VE: "ונצואלה",
  VN: "וייטנאם",
  YE: "תימן",
  ZA: "דרום אפריקה",
  ZM: "זמביה",
  ZW: "זימבבואה",
};

const VALID_CODES = new Set(Object.keys(countries));

/** קוד ISO → שם לתצוגה (עברית או אנגלית מ־countries-list) */
export function getNationalityDisplayLabel(code) {
  if (code == null || code === "") return "";
  const c = String(code).toUpperCase();
  if (COUNTRY_NAME_HE[c]) return COUNTRY_NAME_HE[c];
  const meta = countries[c];
  return meta ? meta.name : c;
}

/**
 * אפשרויות ל-Ant Design Select: value = קוד ISO2, label לתצוגה וחיפוש.
 */
export function buildFlightNationalitySelectOptions() {
  return Object.keys(countries)
    .map((code) => {
      const meta = countries[code];
      const nameHe = COUNTRY_NAME_HE[code];
      const nameEn = meta?.name ?? code;
      const label = nameHe ? `${nameHe} (${code})` : `${nameEn} (${code})`;
      return {
        value: code,
        label,
        nameHe: nameHe || null,
        nameEn,
      };
    })
    .sort((a, b) =>
      a.label.localeCompare(b.label, "he", { sensitivity: "base" })
    );
}

let _optionsCache;

export function getFlightNationalitySelectOptions() {
  if (!_optionsCache) _optionsCache = buildFlightNationalitySelectOptions();
  return _optionsCache;
}

export function isValidPassengerNationalityCode(code) {
  if (code == null || code === "") return false;
  return VALID_CODES.has(String(code).toUpperCase());
}

/** בניית מפה הפוכה: שם עברי/אנגלית (מנורמל) → קוד */
function buildNameToCodeMap() {
  const m = new Map();
  for (const code of VALID_CODES) {
    const meta = countries[code];
    const he = COUNTRY_NAME_HE[code];
    if (he) {
      m.set(he.trim().toLowerCase(), code);
    }
    if (meta?.name) {
      m.set(String(meta.name).trim().toLowerCase(), code);
    }
    m.set(code.toLowerCase(), code);
  }
  return m;
}

let _nameToCodeCache;

function getNameToCodeMap() {
  if (!_nameToCodeCache) _nameToCodeCache = buildNameToCodeMap();
  return _nameToCodeCache;
}

/**
 * ניסיון להמיר טקסט חופשי / קוד ל-ISO2 (למיגרציה עדינה מטפסים ישנים).
 * @returns {string|null} קוד או null
 */
export function tryResolveNationalityToIso2(raw) {
  if (raw == null || raw === "") return null;
  const s = String(raw).trim();
  if (!s) return null;
  const two = s.toUpperCase();
  if (two.length === 2 && VALID_CODES.has(two)) return two;
  const map = getNameToCodeMap();
  const hit = map.get(s.toLowerCase());
  return hit || null;
}

/**
 * אם יש קוד שלא ברשימה (נדיר), הוספת אופציה כדי שלא תאבד בחירה בטופס.
 */
export function buildFlightNationalityOptionsWithFallback(storedCode) {
  const base = getFlightNationalitySelectOptions();
  const c =
    storedCode == null || storedCode === ""
      ? ""
      : String(storedCode).toUpperCase();
  if (!c) return base;
  if (base.some((o) => o.value === c)) return base;
  return [
    {
      value: c,
      label: `${c} (לא ברשימה — נתון קיים)`,
      nameHe: null,
      nameEn: c,
    },
    ...base,
  ];
}

/**
 * חיפוש ב-select: קוד, שם עברי, שם אנגלית.
 */
export function filterFlightNationalityOption(input, option) {
  const q = String(input || "").trim().toLowerCase();
  if (!q) return true;
  const v = String(option?.value ?? "").toLowerCase();
  const label = String(option?.label ?? "").toLowerCase();
  const nameEn = String(option?.nameEn ?? "").toLowerCase();
  const nameHe = String(option?.nameHe ?? "").toLowerCase();
  return (
    v.includes(q) ||
    label.includes(q) ||
    nameEn.includes(q) ||
    (nameHe && nameHe.includes(q))
  );
}
